import { StoreState } from "@/redux/RootReducer";
import { CustomerAgreementTabState } from "./reducers";

export const customerAgreementSelectors = {
  getTabState: (state: StoreState): CustomerAgreementTabState =>
    state.customerAgreement.customerAgreementTabState,
};
